module.exports = __webpack_public_path__ + "static/story10-0080ce142e7dc68fcdf1356d90757320.png";